import { ErrorResult } from 'src/generated/graphql'

export const isErrorResult = (
  result: unknown
): result is Pick<ErrorResult, '__typename'> => {
  return (result as ErrorResult)?.__typename === 'ErrorResult'
}
